import { Eye, EyeOff } from "lucide-react";
import * as React from "react";

import { cn } from "@/lib/cn";

interface MaskableInputProps extends Omit<React.ComponentProps<"input">, "type"> {
  maskByDefault?: boolean;
  maskChar?: string;
}

export const MaskableInput = ({
  className,
  maskByDefault = true,
  maskChar = "disc",
  ...props
}: MaskableInputProps) => {
  const [masked, setMasked] = React.useState(maskByDefault);

  return (
    <div className="relative">
      <input
        type="text"
        data-slot="input"
        className={cn(
          // Layout
          "flex h-12 w-full px-4 py-3 pr-12",
          // Background & Border
          "rounded-sm bg-neutral-200/2",
          "border-2 border-transparent transition-colors",
          // Typography
          "fs-300 font-semibold text-neutral-200",
          // Placeholder
          "placeholder:font-semibold placeholder:text-neutral-200/22",
          // Hover state
          "hover:border-neutral-200/22",
          // Focus state
          "focus-visible:border-primary-800/63 focus-visible:outline-none",
          // Disabled state
          "disabled:pointer-events-none disabled:cursor-not-allowed disabled:text-neutral-200/12",
          // Invalid state
          "aria-invalid:border-danger",
          // Autofill - neutral-900 bg (dark), neutral-200 text
          "autofill:shadow-[inset_0_0_0px_1000px_#101012] autofill:[-webkit-text-fill-color:#bfbfbf]",
          className
        )}
        style={
          masked
            ? ({
                WebkitTextSecurity: maskChar,
                textSecurity: maskChar,
              } as React.CSSProperties)
            : undefined
        }
        {...props}
      />

      <button
        type="button"
        onClick={() => setMasked((prev) => !prev)}
        className="text-primary-400 hover:text-primary-500 absolute top-1/2 right-4 -translate-y-1/2 cursor-pointer transition-colors"
        tabIndex={-1}
        aria-label={masked ? "Показать значение" : "Скрыть значение"}
      >
        {masked ? <Eye className="size-5" /> : <EyeOff className="size-5" />}
      </button>
    </div>
  );
};
